__turbopack_context__.v({
  "details": "DescriptionList-module-scss-module__FP4HMW__details",
  "fade-in": "DescriptionList-module-scss-module__FP4HMW__fade-in",
  "list": "DescriptionList-module-scss-module__FP4HMW__list",
  "listDefault": "DescriptionList-module-scss-module__FP4HMW__listDefault",
  "listEqualWidth": "DescriptionList-module-scss-module__FP4HMW__listEqualWidth",
  "listSeparated": "DescriptionList-module-scss-module__FP4HMW__listSeparated",
  "no-transform": "DescriptionList-module-scss-module__FP4HMW__no-transform",
  "rotate": "DescriptionList-module-scss-module__FP4HMW__rotate",
  "term": "DescriptionList-module-scss-module__FP4HMW__term",
});
